// src/components/ProductImageModal.jsx
import React, { useEffect } from "react";
import { createPortal } from "react-dom";

export default function ProductImageModal({ src, alt = "", onClose }) {
  // zatvaranje na ESC i klik na pozadinu
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!src) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative max-w-[95vw] max-h-[95vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={alt}
          className="max-w-[95vw] max-h-[90vh] object-contain rounded shadow-lg"
        />
        <div className="absolute top-2 right-2 flex gap-2">
          <a
            href={src}
            target="_blank"
            rel="noreferrer"
            className="px-3 py-1 rounded bg-white/90 text-sm"
          >
            Open in new tab
          </a>
          <button
            onClick={onClose}
            className="px-3 py-1 rounded bg-white/90 text-sm"
          >
            Close ✕
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
